import { icon, type IconRenderer } from "@godown/element";

const _default: IconRenderer = icon(
  "0 0 256 256",
)`<path fill="currentColor" d="M165.66 202.34a8 8 0 0 1-11.32 11.32l-80-80a8 8 0 0 1 0-11.32l80-80a8 8 0 0 1 11.32 11.32L91.31 128Z">`;

export default _default;
